<div class="relative" [pandoraOnClickOutside]="closePanel">
    <!-- Bell trigger -->
    <button
        type="button"
        (click)="toggle()"
        class="relative -m-1.5 p-1.5 text-gray-700 hover:text-gray-900"
        aria-label="Meldingen"
    >
        <app-icon [icon]="bellIcon" size="nav" />

        @if (unreadCount() > 0) {
            <span
                class="absolute -top-0.5 -right-0.5 flex h-4 min-w-4 items-center justify-center rounded-full bg-red-500 px-1 text-[10px] font-semibold leading-none text-white"
            >
                {{ unreadCount() > 9 ? '9+' : unreadCount() }}
            </span>
        }
    </button>

    <!-- Dropdown panel -->
    @if (open()) {
        <div
            class="absolute right-0 mt-2 w-80 max-w-[calc(100vw-2rem)] rounded-lg border border-gray-200 bg-white shadow-lg z-20"
        >
            <div class="flex items-center justify-between border-b border-gray-100 px-4 py-3">
                <span class="text-sm font-semibold text-gray-900">Meldingen</span>

                @if (unreadCount() > 0) {
                    <button
                        type="button"
                        (click)="markAllAsRead()"
                        class="flex items-center gap-1 text-xs font-medium text-blue-600 hover:text-blue-700"
                    >
                        <app-icon [icon]="checkIcon" size="table" />
                        Alles als gelezen
                    </button>
                }
            </div>

            <div class="max-h-96 overflow-y-auto">
                @for (notification of notifications(); track notification.id) {
                    <button
                        type="button"
                        (click)="onNotificationClick(notification)"
                        class="flex w-full items-start gap-3 border-b border-gray-50 px-4 py-3 text-left hover:bg-gray-50 last:border-b-0"
                    >
                        <app-icon
                            [icon]="iconFor(notification.type)"
                            size="card"
                            class="mt-0.5 shrink-0 text-gray-400"
                        />
                        <span class="flex flex-col items-start gap-0.5">
                            <span class="text-sm font-medium text-gray-900">{{ notification.title }}</span>
                            <span class="text-sm text-gray-600">{{ notification.message }}</span>
                            <span class="mt-0.5 text-xs text-gray-400">{{ notification.createdAt | timeAgo }}</span>
                        </span>
                    </button>
                } @empty {
                    <div class="flex flex-col items-center gap-2 px-4 py-8 text-center text-gray-400">
                        <app-icon [icon]="bellOffIcon" size="card" />
                        <span class="text-sm">Geen nieuwe meldingen</span>
                    </div>
                }
            </div>

            <a
                routerLink="/meldingen"
                (click)="closePanel()"
                class="block border-t border-gray-100 px-4 py-2.5 text-center text-xs font-medium text-blue-600 hover:bg-gray-50 hover:text-blue-700"
            >
                Alle meldingen bekijken
            </a>
        </div>
    }
</div>
